<template>
  <v-layout wrap style="align-items: center" class="mb-2" v-if="followup_schedule_time">
    <v-flex xs6 sm2>
      <v-autocomplete
        class="mb-2"
        v-model="followup_schedule_time.days"
        :items="dayOptions"
        outline
        hide-details
        dense
        single-line
        @change="handleChangeTime('days', $event)"
      />
    </v-flex>
    <v-flex xs6 sm2 class="pl-2">Days</v-flex>
    <v-flex xs6 sm2>
      <v-autocomplete
        class="mb-2"
        v-model="followup_schedule_time.hours"
        :items="hourOptions"
        outline
        hide-details
        dense
        single-line
        @change="handleChangeTime('hours', $event)"
      />
    </v-flex>
    <v-flex xs6 sm2 class="pl-2">Hours</v-flex>
    <v-flex xs6 sm2>
      <v-autocomplete
        class="mb-2"
        v-model="followup_schedule_time.minutes"
        :items="minuteOptions"
        outline
        hide-details
        dense
        single-line
        @change="handleChangeTime('minutes', $event)"
      />
    </v-flex>
    <v-flex xs6 sm2 class="pl-2">Minutes</v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      dayOptions: [...Array(365)].map((val, index) => index.toString()),
      hourOptions: [...Array(24)].map((val, index) => index.toString().padStart(2, '0')),
      minuteOptions: [...Array(12)].map((val, index) => (index * 5).toString().padStart(2, '0')),
      followup_schedule_time: null
    }
  },
  mounted() {
    this.handleInitTime(this.value)
  },
  methods: {
    getReturnValues(duration) {
      const days = Math.floor(duration / (1000 * 60 * 60 * 24))
      const hours = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((duration % (1000 * 60)) / 1000)

      return [days, hours, minutes, seconds]
    },
    handleChangeTime(type, event) {
      const time = this.followup_schedule_time
      // convert to total second
      this.$emit(
        'input',
        parseInt(time.days) * 24 * 60 + parseInt(time.hours) * 60 + parseInt(time.minutes)
      )
    },
    handleInitTime(value) {
      const followup_schedule_time = (typeof value == 'string' ? parseInt(value) : 0) * 60 * 1000 // minute to milisecound
      const [days, hours, minutes, seconds] = this.getReturnValues(followup_schedule_time)

      this.followup_schedule_time = {
        days: days.toString(),
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0')
      }
    }
  },
  watch: {
    value: (newVal) => {
      this.handleInitTime(newVal)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GeneraliTimePicker.vue